import { LabelWithHelp } from "@components/common/label-with-help";
import {
  AccessLevelEntityType,
  getAccessLevelDescription,
  AccessLevelDisplayNames,
} from "@components/access-level/access-level-utils";
import { Box } from "@mui/material";
import { neutral } from "@flat-ui";

interface Props {
  /** The type of entity for which the access level is shown */
  type: AccessLevelEntityType;
}

/** Tooltip for access level component */
export function AccessLevelTooltip({ type }: Props): JSX.Element {
  return (
    <LabelWithHelp
      title="Access Level"
      help={
        <Box component="div">
          <Box component="div" mb="20px">
            There are two types of access levels:
          </Box>
          <Box component="div" mb="20px">
            {`${AccessLevelDisplayNames.private} - ${getAccessLevelDescription(
              type,
              "private"
            )}`}
          </Box>
          <Box component="div">
            {`${AccessLevelDisplayNames.unlisted} - ${getAccessLevelDescription(
              type,
              "unlisted"
            )}`}
          </Box>
        </Box>
      }
      sx={{
        color: neutral[500],
        fontWeight: "normal",
        width: "fit-content",
        fontSize: "11px",
      }}
    />
  );
}
